import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import axios from 'utils/axios';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

// project imports
import ScrollTop from 'components/ScrollTop';

export default function AdminLayout() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post('/v1/admin/logout');
    } catch(e) {}
    localStorage.removeItem('gpo_admin_token');
    navigate('/login', { replace: true });
  };

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <ScrollTop />
      
      <AppBar position="fixed" elevation={0} sx={{ borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', color: 'text.primary' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Typography variant="h5">GPO Superadmin</Typography>
          <Button color="error" onClick={handleLogout}>Sair</Button>
        </Toolbar>
      </AppBar>

      <Box component="main" sx={{ width: '100%', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
        <Toolbar sx={{ mt: 'inherit' }} />
        <Box
          sx={{
            ...{ px: { xs: 0, sm: 2 } },
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
